import React, { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { RoleEnum } from "../../../types/eventTypes";
import { IInvoice } from "../../../types/commonTypes";
import { Link } from "@mui/material";
import DownloadSimpleIcon from "../../../assets/svg-fc/DownloadSimpleIcon";
import { fetchPdfMedia } from "../../../helpers/common";
import { useToast } from "../../../context/ToasterContext";

interface IInvoicesLinksProps {
	invoices: IInvoice[];
	openPdfFile?: (url: string) => void;
}

const ViewInvoicesLinks: FC<IInvoicesLinksProps> = ({ invoices = [], openPdfFile }) => {
	const { showToast } = useToast();

	const openPdfFileHandler = async (url: string) => {
		if (openPdfFile) {
			openPdfFile(url);
			return;
		}
		const isOpened = await fetchPdfMedia(url);
		if (!isOpened) {
			showToast("Allow browser popups to view media", () => {}, "warning");
		}
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				rowGap: "8px",
				"@media (max-width: 1024px)": {
					paddingInline: 0,
					marginBottom: "100px",
				},
			}}
		>
			{[...invoices]
				.sort((a, b) => (a.role === RoleEnum.Admin ? -1 : b.role === RoleEnum.Admin ? 1 : 0))
				?.map((invoice) => {
					return (
						<Link
							underline="none"
							onClick={() => {
								openPdfFileHandler(invoice.invoice);
							}}
							sx={{
								cursor: "pointer",
								display: "inline-flex",
								alignItems: "center",
								gap: "8px",
							}}
						>
							<Typography
								component="span"
								sx={{
									textDecoration: "underline",
									fontSize: 16,
									fontWeight: 500,
									"@media (min-width: 1024px)": {
										fontSize: 18,
									},
								}}
							>
								{invoice.role === RoleEnum.Admin
									? "Download commission invoice pdf"
									: invoice.role === RoleEnum.Vendor
										? "Download vendor invoice pdf"
										: "Download invoice pdf"}
							</Typography>
							<Typography
								component="span"
								sx={{
									textDecoration: "underline",
									display: "flex",
									alignItems: "center",
								}}
							>
								<DownloadSimpleIcon />
							</Typography>
						</Link>
					);
				})}
		</Box>
	);
};
export default ViewInvoicesLinks;
